var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"wiget"},[_c('Row',[_c('Col',[_c('h3',{staticClass:"count"},[_vm._v(_vm._s(_vm.count))]),_vm._v(" "),_c('p',{staticClass:"subText"},[_vm._v(_vm._s(_vm.name))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }